module.exports = __webpack_public_path__ + "static/media/user.9d21b7ac.svg";